import {
  getFieldNameFromEqlField,
  isCountForFunctionRequired,
} from '@modules/common/utils';
import { useAddApplyTaxonomyFunctionIfRequired } from '@modules/quantify/hooks/useAddApplyTaxonomyFunctionIfRequired';
import { useAddFormulaFunctionIfRequired } from '@modules/quantify/hooks/useAddFormulaFunctionIfRequired';
import { useAddOrderFunctionIfRequired } from '@modules/quantify/hooks/useAddOrderFunctionIfRequired';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { EQLFunction, EQLFunctionName } from 'v2/core/repository/eql/types';
import { shallow } from 'zustand/shallow';

export const useGetQuantifyChartEQLFunctions = () => {
  const {
    groupBy,
    compareTo,
    shouldShowTopDataPoints,
    topDataPointsSelectionCount,
    visibleDataPoints,
    shouldShowAllValues,
  } = useQuantifyStore(({ metadata, query }) => {
    return {
      shouldShowTopDataPoints: metadata.shouldShowTopDataPoints,
      topDataPointsSelectionCount: metadata.topDataPointsSelectionCount,
      groupBy: query.groupBy,
      visibleDataPoints: metadata.visibleDataPoints,
      compareTo: query.compareTo,
      shouldShowAllValues: metadata.shouldShowAllValues,
    };
  }, shallow);

  const functions: EQLFunction[] = [];

  const addApplyTaxonomyFunctionIfRequired =
    useAddApplyTaxonomyFunctionIfRequired();
  const addFormulaFunctionIfRequired = useAddFormulaFunctionIfRequired({
    variant: 'chart',
  });
  const addOrderFunctionIfRequired = useAddOrderFunctionIfRequired();

  addApplyTaxonomyFunctionIfRequired(functions);
  addFormulaFunctionIfRequired(functions);
  addOrderFunctionIfRequired(functions);

  const eqlFieldName = groupBy ? getFieldNameFromEqlField(groupBy) : undefined;
  const shouldUseCountForFunction = isCountForFunctionRequired({
    eqlFieldName,
    shouldShowAllValues,
    shouldShowTopDataPoints,
    variant: 'chart',
    visibleDataPoints,
  });

  // Avoid applying pagination limit when statically selecting rows, as it's not suitable for TK+Categories.
  if (!shouldUseCountForFunction) {
    functions.push({
      name: compareTo
        ? EQLFunctionName.DeltaPaginate
        : EQLFunctionName.Paginate,
      params: [
        shouldShowTopDataPoints
          ? topDataPointsSelectionCount
          : visibleDataPoints.length,
        1,
      ],
    });
  }

  return functions;
};
